export enum EnergyType {
    Both = 'both',
    Electricity = 'electricity',
    Gas = 'gas',
}
